export default "__VITE_ASSET__CkArtDE2__"